import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMessage } from '../../contexts/MessageContext'
import { useApi } from '../../utils/api'
import { PageTitleBar } from '../../components/PageTitleBar'
import { FormLabel, FormInput, FormButton, CancelButton } from '../../components/forms/FormElements'

interface FormData {
  title: string;
}

export default function NewContentGroup() {
  const { setMessage } = useMessage()
  const { fetchWithAuth } = useApi()
  const [formData, setFormData] = useState<FormData>({
    title: '',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prevData => ({ ...prevData, [name]: value }))
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsSubmitting(true)
    setError(null)

    try {
      const response = await fetchWithAuth('/admin/content-groups', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: formData.title,
        }),
      })

      if (!response.ok) {
        throw new Error('Failed to create content group')
      }

      const data = await response.json()
      console.log('Content group created:', data)
      setMessage('Content group successfully created!')
      navigate('/content-groups')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      <main className="container mx-auto px-4 py-8">
        <PageTitleBar
          title="New Content Group"
          breadcrumbs={[
            { label: 'Dashboard', href: '/' },
            { label: 'Content Groups', href: '/content-groups' },
            { label: 'New Content Group' },
          ]}
        />

        <div className="bg-white rounded-sm border border-gray-200 p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <FormLabel htmlFor="title">TITLE</FormLabel>
              <FormInput
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
                autoFocus
              />
            </div>

            <div className="flex justify-end space-x-3">
              <CancelButton type="button" onClick={() => navigate('/content-groups')}>
                Cancel
              </CancelButton>
              <FormButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </FormButton>
            </div>
            {error && <div className="text-red-500 mt-2">{error}</div>}
          </form>
        </div>
      </main>
    </div>
  )
} 